// Plain CommonJS on purpose (module.exports, not `export`): routes/*.js files
// are required directly by server.js under plain `node index.js` — no babel
// or webpack in that path — so they cannot `require()` an ES-module-syntax
// file. helpers/encryption.js (ES module, compiled by webpack, shipped into
// BOTH the server bundle and the browser bundle) imports this same constant
// so there is exactly one hardcoded copy of the key instead of two.
//
// security-hardening-2026: NOT sourced from process.env on purpose.
// encryptString/decryptString in helpers/encryption.js run on the server
// (real process.env) AND in the browser bundle (webpack stubs process.env to
// {} unless a key is explicitly allowlisted in next.config.js's DefinePlugin
// — kept secret-free there deliberately). Making this key env-configurable
// server-side only, while the browser silently kept this literal default,
// would make server-encrypted and client-encrypted cookies/tokens mutually
// undecryptable the instant anyone set the env var — a full authentication
// outage. Until the client-side encrypt/decrypt path is removed (so this
// becomes a single trusted server-only value), it has to stay one literal
// shared by both sides. Rotate it here if it must rotate.
module.exports = "MFSKeyX2022";
